// eslint-disable react/no-danger
import React, { useEffect, useState } from 'react';
import './index.less';
import './index.h5.less';
import { getUserRegion } from '@service/api';
import { useTranslation } from '@ies/intl-react-plugin';

const LocationOff: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div className="location-off">
            <div className="location-off-desc" dangerouslySetInnerHTML={{ __html: t('region_forbidden') }} />
        </div>
    );
};

export default function useLocationOff() {
    const [isUsRegion, setIsUsRegion] = useState(false);
    const getUserLocation = async () => {
        try {
            const resp = await getUserRegion();
            const isUserBan = Boolean(resp?.data?.is_open_us_ban && resp?.data?.is_us_user);
            setIsUsRegion(isUserBan);
        } catch {
            setIsUsRegion(false);
        }
    };

    useEffect(() => {
        getUserLocation();
    }, []);

    return {
        LocationOff,
        isOff: isUsRegion,
    };
}
